import React from "react";
import { Link } from "react-router-dom";
import { signatureServices } from "../../data/signatureServices";
import { SectionLabel } from "../SectionLabel";
export function WaysWeStepIn() {
  return <section id="ways-we-step-in" aria-labelledby="step-in-title" className="scroll-mt-28 border-t border-stone" data-id="element-599" data-mp="58igbo449dnv">
      <div className="shell py-24 md:py-32" data-id="element-600" data-mp="18q3gz7owlcp">
        <div className="grid grid-cols-12 gap-x-6 gap-y-12 pb-16 md:pb-24" data-id="element-601" data-mp="15vkzd88lalx">
          <div className="col-span-12 lg:col-span-6" data-id="element-602" data-mp="xx65vvvwep78">
            <SectionLabel data-id="element-603" data-mp="sycohsdhqe1s">Ways we step in</SectionLabel>
            <h2 id="step-in-title" className="mt-6 font-display text-[clamp(2.5rem,5vw,4.5rem)] leading-[1.02] tracking-[-0.01em] text-navy" data-id="element-604" data-mp="swrvi76tr361">
              Specific problems. Specific ways to hire us.
            </h2>
            <p className="mt-6 max-w-md text-lg leading-relaxed text-charcoal/80" data-id="element-605" data-mp="39ojitaqabqs6">
              Six of the most common reasons organizations call Constant — each one something you can engage us to do
              this week.
            </p>
          </div>
          <nav aria-label="Ways we step in" className="col-span-12 lg:col-span-5 lg:col-start-8 lg:self-end" data-id="element-606" data-mp="2w3t9nmrwwwpo">
            <ol className="border-t border-navy" data-id="element-607" data-mp="2i4adlscdlbtq">
              {signatureServices.map(s => <li key={s.id} className="border-b border-stone" data-id="element-608" data-mp="2n2v6f6past85">
                  <a href={`#${s.id}`} className="group flex items-baseline gap-5 py-3.5" data-id="element-609" data-mp="2n57wk757m9wa">
                    <span className="w-6 text-sm tabular-nums text-oxblood" data-id="element-610" data-mp="28cwa79hazrvb">{s.number}</span>
                    <span className="font-display text-xl text-navy transition-colors duration-150 group-hover:text-oxblood" data-id="element-611" data-mp="2d68ksfp5dy52">
                      {s.name}
                    </span>
                  </a>
                </li>)}
            </ol>
          </nav>
        </div>

        <ol className="space-y-24 md:space-y-32" data-id="element-612" data-mp="1pgnzhq5iuosm">
          {signatureServices.map((s, i) => {
          const flip = i % 2 === 1;
          return <li key={s.id} id={s.id} className="scroll-mt-28" data-id="element-613" data-mp="3w3dc1pfy0jp1" data-mpi={i}>
                <article aria-labelledby={`${s.id}-name`} className="grid grid-cols-12 items-center gap-x-6 gap-y-10" data-id="element-614" data-mp="c1jotmvll9">
                  <div className={`col-span-12 lg:col-span-5 ${flip ? "lg:order-2 lg:col-start-8" : ""}`} data-id="element-615" data-mp="3nbbcruhm19gc">
                    <div className="aspect-[5/4] overflow-hidden bg-stone" data-id="element-616" data-mp="3icgwp0b11yzx">
                      <img src={s.image.src} alt={s.image.alt} loading="lazy" className="h-full w-full object-cover" data-id="element-617" data-mp="3iadu7gsoudeb" />
                    </div>
                  </div>

                  <div className={`col-span-12 lg:col-span-6 ${flip ? "lg:order-1 lg:col-start-1" : "lg:col-start-7"}`} data-id="element-618" data-mp="ew00ayg6nghr">
                    <div className="flex items-center gap-4" data-id="element-619" data-mp="9yhz5u8eq5kb">
                      <span className="font-display text-2xl tabular-nums text-oxblood" data-id="element-620" data-mp="4w97d179t9js">{s.number}</span>
                      <span aria-hidden className="block h-px flex-1 bg-oxblood/40" data-id="element-621" data-mp="2unfg2ps1jhjk" />
                    </div>
                    <h3 id={`${s.id}-name`} className="mt-6 font-display text-[clamp(2.25rem,4vw,3.5rem)] leading-[1.04] text-navy" data-id="element-622" data-mp="2plyk98oeyl9u">
                      {s.name}
                    </h3>
                    <p className="mt-4 font-display text-xl italic leading-snug text-oxblood md:text-2xl" data-id="element-623" data-mp="2ph8zai3epl6n">{s.hook}</p>
                    <p className="mt-6 max-w-lg text-[17px] leading-relaxed text-charcoal/85" data-id="element-624" data-mp="2u9kawi7ievf1">{s.description}</p>
                    <ul className="mt-8 grid grid-cols-1 gap-x-8 border-b border-stone sm:grid-cols-2" data-id="element-625" data-mp="2y9ay6bxtutet">
                      {s.examples.map(ex => <li key={ex} className="border-t border-stone py-2.5 text-[15px] text-charcoal" data-id="element-626" data-mp="388jn2qdu5hub">
                          {ex}
                        </li>)}
                    </ul>
                    <Link to={s.ctaTo} className="btn-primary mt-10" data-id="element-627" data-mp="1dusfdwf2h81i">
                      {s.ctaLabel}
                    </Link>
                  </div>
                </article>
              </li>;
        })}
        </ol>
      </div>
    </section>;
}